import { atom } from "recoil";

const optionErrorAtom = atom({
    key: 'optionError',
    default: { Name: '', Type: '' }
})

export {optionErrorAtom}